import React from "react";
import Slider from "react-slick";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";
import "../../styles/hero-slider.css";

const HeroSlider = () => {
  const t = useTranslation();
  const settings = {
    fade: true,
    speed: 1000,
    autoplaySpeed: 3000,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    dots: true,
    arrows: false,
  };

  return (
    <Slider {...settings} className="hero__slider" style={{marginTop:'-17px'}}>
      {/* Slide 1 - Featured Project */}
      <div className="slider__item slider__item-01">
        <Container>
          <Row>
            <Col lg="6" md="6">
              <div className="slider__content">
                <h6>{t("services.title")}</h6>
                <h1>{t("hero.slide1.title")}</h1>
                <p>{t("hero.slide1.description")}</p>
                <button className="explore__btn">
                  <Link to="/projects">{t("hero.slide1.button")}</Link>
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Slide 2 - Company Story */}
      <div className="slider__item slider__item-02">
        <Container>
          <Row>
            <Col lg="6" md="6">
              <div className="slider__content">
                <h6>{t("services.title")}</h6>
                <h1>{t("hero.slide2.title")}</h1>
                <p>{t("hero.slide2.description")}</p>
                <button className="explore__btn">
                  <Link to="/about">{t("hero.slide2.button")}</Link>
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Slide 3 - Services */}
      <div className="slider__item slider__item-03">
        <Container>
          <Row>
            <Col lg="6" md="6">
              <div className="slider__content">
                <h6>{t("services.title")}</h6>
                <h1>{t("hero.slide3.title")}</h1>
                <p>{t("hero.slide3.description")}</p>
                <button className="explore__btn">
                  <Link to="/services">{t("hero.slide3.button")}</Link>
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Slider>
  );
};

export default HeroSlider;
